import { lazy } from 'react';
import Lottie from 'lottie-react';

import book_ride_animation from '../../lotties/book_ride.json';
import break_animation from '../../lotties/break.json';
import bus_delay from '../../lotties/bus-delay.json';
import completed_animation from '../../lotties/completed.json';
import delete_ticket_animation from '../../lotties/delete_ticket.json';
import documents_upload_animation from '../../lotties/documents_upload.json';
import end_subscription from '../../lotties/end-subscription.json';
import error_animation from '../../lotties/error.json';
import impaired_card_animation from '../../lotties/impaired_card.json';
import license_animation from '../../lotties/license.json';
import map_animation from '../../lotties/map.json';
import mopla_dticket_animation from '../../lotties/mopla_dticket_animation.json';
import mopla_ticket_animation from '../../lotties/mopla_ticket_animation.json';
import picture_upload_animation from '../../lotties/picture_upload.json';
import ride_notification_animation from '../../lotties/ride_notification.json';
import right_ride_animation from '../../lotties/right_ride.json';
import sad_face from '../../lotties/sad_face.json';
import no_vehicle from '../../lotties/searching-trip_not_found.json';
import stay_informed_animation from '../../lotties/stay_informed.json';
import travel_animation from '../../lotties/travel.json';
import vehicle_check_animation from '../../lotties/vehicle_check.json';
import verification_animation from '../../lotties/verification.json';
import no_internet_animation from '../../lotties/wifi.json';

import { AspectRatioGuardStyled } from './Anim.styles';
import { SuspenseGuard } from './SuspenseGuard';
import type { LC } from './types';

export const BookRideAnim = (props: LC) => (
	<AspectRatioGuardStyled>
		<Lottie animationData={book_ride_animation} loop={false} {...props} />
	</AspectRatioGuardStyled>
);
export const BreakAnim = (props: LC) => (
	<AspectRatioGuardStyled>
		<Lottie animationData={break_animation} loop={false} {...props} />
	</AspectRatioGuardStyled>
);
export const CompleteAnim = (props: LC) => (
	<AspectRatioGuardStyled>
		<Lottie animationData={completed_animation} loop={false} {...props} />
	</AspectRatioGuardStyled>
);
export const DelteTicketAnim = (props: LC) => (
	<AspectRatioGuardStyled>
		<Lottie animationData={delete_ticket_animation} loop={false} {...props} />
	</AspectRatioGuardStyled>
);
export const DocumentsUploadAnim = (props: LC) => (
	<AspectRatioGuardStyled>
		<Lottie
			animationData={documents_upload_animation}
			loop={false}
			{...props}
		/>
	</AspectRatioGuardStyled>
);
export const ErrorAnim = (props: LC) => (
	<AspectRatioGuardStyled>
		<Lottie animationData={error_animation} loop={false} {...props} />
	</AspectRatioGuardStyled>
);
export const FailedAnim = (props: LC) => (
	<AspectRatioGuardStyled>
		<Lottie animationData={end_subscription} loop={false} {...props} />
	</AspectRatioGuardStyled>
);
export const SadFaceAnim = (props: LC) => (
	<AspectRatioGuardStyled>
		<Lottie animationData={sad_face} loop={false} {...props} />
	</AspectRatioGuardStyled>
);
export const ImpairedCardAnim = (props: LC) => (
	<AspectRatioGuardStyled>
		<Lottie animationData={impaired_card_animation} loop={false} {...props} />
	</AspectRatioGuardStyled>
);
export const LicenceAnim = (props: LC) => (
	<AspectRatioGuardStyled>
		<Lottie animationData={license_animation} loop={false} {...props} />
	</AspectRatioGuardStyled>
);
export const MapAnim = (props: LC) => (
	<AspectRatioGuardStyled>
		<Lottie animationData={map_animation} loop={false} {...props} />
	</AspectRatioGuardStyled>
);
export const PicUploadAnim = (props: LC) => (
	<AspectRatioGuardStyled>
		<Lottie animationData={picture_upload_animation} loop={false} {...props} />
	</AspectRatioGuardStyled>
);
export const RideNotificationAnim = (props: LC) => (
	<AspectRatioGuardStyled>
		<Lottie
			animationData={ride_notification_animation}
			loop={false}
			{...props}
		/>
	</AspectRatioGuardStyled>
);
export const RightRideAnim = (props: LC) => (
	<AspectRatioGuardStyled>
		<Lottie animationData={right_ride_animation} loop={false} {...props} />
	</AspectRatioGuardStyled>
);
export const StayInformedAnim = (props: LC) => (
	<AspectRatioGuardStyled>
		<Lottie animationData={stay_informed_animation} loop={false} {...props} />
	</AspectRatioGuardStyled>
);
export const TravelAnim = (props: LC) => (
	<AspectRatioGuardStyled>
		<Lottie animationData={travel_animation} loop={false} {...props} />
	</AspectRatioGuardStyled>
);
export const VehicleCheckAnim = (props: LC) => (
	<AspectRatioGuardStyled>
		<Lottie animationData={vehicle_check_animation} loop={false} {...props} />
	</AspectRatioGuardStyled>
);
export const VerificationAnim = (props: LC) => (
	<AspectRatioGuardStyled>
		<Lottie animationData={verification_animation} loop={false} {...props} />
	</AspectRatioGuardStyled>
);
export const OfflineCardAnim = (props: LC) => (
	<AspectRatioGuardStyled>
		<Lottie animationData={no_internet_animation} loop={false} {...props} />
	</AspectRatioGuardStyled>
);
export const NoVehicleFound = (props: LC) => (
	<AspectRatioGuardStyled>
		<Lottie animationData={no_vehicle} loop={false} {...props} />
	</AspectRatioGuardStyled>
);

/**
 * TODO: RPA - Redesign animated mopla logo
 * @deprecated
 */
export const MoplaTicketAnim = (props: LC) => (
	<Lottie animationData={mopla_ticket_animation} loop={true} {...props} />
);

export const MoplaDTicketAnim = (props: LC) => (
	<Lottie animationData={mopla_dticket_animation} loop={true} {...props} />
);

export const BusDelayAnim = (props: LC) => (
	<Lottie animationData={bus_delay} loop={true} {...props} />
);

const LazyTripSearchAnim = lazy(() => import('./TripSearchAnim'));
export const TripSearchAnim = (props: LC) => (
	<SuspenseGuard fallbackHeight={376}>
		<LazyTripSearchAnim {...props} />
	</SuspenseGuard>
);
